/**
 * orga-app-api - benutzerverwaltung-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { FunktionsbereichAnlegenRequest } from '../model/funktionsbereichAnlegenRequest';
// @ts-ignore
import { FunktionsbereichBenutzerMultiRequest } from '../model/funktionsbereichBenutzerMultiRequest';
// @ts-ignore
import { FunktionsbereichBenutzerRequest } from '../model/funktionsbereichBenutzerRequest';
// @ts-ignore
import { FunktionsbereichEmpfaengerRequest } from '../model/funktionsbereichEmpfaengerRequest';
// @ts-ignore
import { FunktionsbereichExpliziteFreigabeErforderlichFestlegenRequest } from '../model/funktionsbereichExpliziteFreigabeErforderlichFestlegenRequest';
// @ts-ignore
import { FunktionsbereichIdentifier } from '../model/funktionsbereichIdentifier';
// @ts-ignore
import { FunktionsbereichRequest } from '../model/funktionsbereichRequest';
// @ts-ignore
import { FunktionsbereichUmbenennenRequest } from '../model/funktionsbereichUmbenennenRequest';
// @ts-ignore
import { RolleMultiRequest } from '../model/rolleMultiRequest';
// @ts-ignore
import { RolleRequest } from '../model/rolleRequest';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class FunktionsbereicheCommandService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * PostFunktionsbereichAdminEntfernen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * FunktionsbereichNichtGefunden: (BenutzerverwaltungFunktionsbereichNichtGefunden) * FunktionsbereichGeloescht: (BenutzerverwaltungFunktionsbereichGeloescht) * KeinFbAdminOderAdminBerechtigung: (BenutzerverwaltungBenutzerKeinFbAdminOderAdmin) 
     * @endpoint post /api/bv/command/funktionsbereiche/v1/admin/entfernen
     * @param funktionsbereichBenutzerRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postFunktionsbereichAdminEntfernen(funktionsbereichBenutzerRequest: FunktionsbereichBenutzerRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<FunktionsbereichIdentifier>;
    public postFunktionsbereichAdminEntfernen(funktionsbereichBenutzerRequest: FunktionsbereichBenutzerRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<FunktionsbereichIdentifier>>;
    public postFunktionsbereichAdminEntfernen(funktionsbereichBenutzerRequest: FunktionsbereichBenutzerRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<FunktionsbereichIdentifier>>;
    public postFunktionsbereichAdminEntfernen(funktionsbereichBenutzerRequest: FunktionsbereichBenutzerRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (funktionsbereichBenutzerRequest === null || funktionsbereichBenutzerRequest === undefined) {
            throw new Error('Required parameter funktionsbereichBenutzerRequest was null or undefined when calling postFunktionsbereichAdminEntfernen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/bv/command/funktionsbereiche/v1/admin/entfernen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<FunktionsbereichIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: funktionsbereichBenutzerRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostFunktionsbereichAdminEntfernenMulti
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * FunktionsbereichNichtGefunden: (BenutzerverwaltungFunktionsbereichNichtGefunden) * FunktionsbereichGeloescht: (BenutzerverwaltungFunktionsbereichGeloescht) * KeinFbAdminOderAdminBerechtigung: (BenutzerverwaltungBenutzerKeinFbAdminOderAdmin) 
     * @endpoint post /api/bv/command/funktionsbereiche/v1/admin/entfernen/multi
     * @param funktionsbereichBenutzerMultiRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postFunktionsbereichAdminEntfernenMulti(funktionsbereichBenutzerMultiRequest: FunktionsbereichBenutzerMultiRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<FunktionsbereichIdentifier>;
    public postFunktionsbereichAdminEntfernenMulti(funktionsbereichBenutzerMultiRequest: FunktionsbereichBenutzerMultiRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<FunktionsbereichIdentifier>>;
    public postFunktionsbereichAdminEntfernenMulti(funktionsbereichBenutzerMultiRequest: FunktionsbereichBenutzerMultiRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<FunktionsbereichIdentifier>>;
    public postFunktionsbereichAdminEntfernenMulti(funktionsbereichBenutzerMultiRequest: FunktionsbereichBenutzerMultiRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (funktionsbereichBenutzerMultiRequest === null || funktionsbereichBenutzerMultiRequest === undefined) {
            throw new Error('Required parameter funktionsbereichBenutzerMultiRequest was null or undefined when calling postFunktionsbereichAdminEntfernenMulti.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/bv/command/funktionsbereiche/v1/admin/entfernen/multi`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<FunktionsbereichIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: funktionsbereichBenutzerMultiRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostFunktionsbereichAdminHinzufuegen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * FunktionsbereichNichtGefunden: (BenutzerverwaltungFunktionsbereichNichtGefunden) * FunktionsbereichGeloescht: (BenutzerverwaltungFunktionsbereichGeloescht) * KeinFbAdminOderAdminBerechtigung: (BenutzerverwaltungBenutzerKeinFbAdminOderAdmin) 
     * @endpoint post /api/bv/command/funktionsbereiche/v1/admin/hinzufuegen
     * @param funktionsbereichBenutzerRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postFunktionsbereichAdminHinzufuegen(funktionsbereichBenutzerRequest: FunktionsbereichBenutzerRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<FunktionsbereichIdentifier>;
    public postFunktionsbereichAdminHinzufuegen(funktionsbereichBenutzerRequest: FunktionsbereichBenutzerRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<FunktionsbereichIdentifier>>;
    public postFunktionsbereichAdminHinzufuegen(funktionsbereichBenutzerRequest: FunktionsbereichBenutzerRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<FunktionsbereichIdentifier>>;
    public postFunktionsbereichAdminHinzufuegen(funktionsbereichBenutzerRequest: FunktionsbereichBenutzerRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (funktionsbereichBenutzerRequest === null || funktionsbereichBenutzerRequest === undefined) {
            throw new Error('Required parameter funktionsbereichBenutzerRequest was null or undefined when calling postFunktionsbereichAdminHinzufuegen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/bv/command/funktionsbereiche/v1/admin/hinzufuegen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<FunktionsbereichIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: funktionsbereichBenutzerRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostFunktionsbereichAdminHinzufuegenMulti
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * FunktionsbereichNichtGefunden: (BenutzerverwaltungFunktionsbereichNichtGefunden) * FunktionsbereichGeloescht: (BenutzerverwaltungFunktionsbereichGeloescht) * KeinFbAdminOderAdminBerechtigung: (BenutzerverwaltungBenutzerKeinFbAdminOderAdmin) 
     * @endpoint post /api/bv/command/funktionsbereiche/v1/admin/hinzufuegen/multi
     * @param funktionsbereichBenutzerMultiRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postFunktionsbereichAdminHinzufuegenMulti(funktionsbereichBenutzerMultiRequest: FunktionsbereichBenutzerMultiRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<FunktionsbereichIdentifier>;
    public postFunktionsbereichAdminHinzufuegenMulti(funktionsbereichBenutzerMultiRequest: FunktionsbereichBenutzerMultiRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<FunktionsbereichIdentifier>>;
    public postFunktionsbereichAdminHinzufuegenMulti(funktionsbereichBenutzerMultiRequest: FunktionsbereichBenutzerMultiRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<FunktionsbereichIdentifier>>;
    public postFunktionsbereichAdminHinzufuegenMulti(funktionsbereichBenutzerMultiRequest: FunktionsbereichBenutzerMultiRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (funktionsbereichBenutzerMultiRequest === null || funktionsbereichBenutzerMultiRequest === undefined) {
            throw new Error('Required parameter funktionsbereichBenutzerMultiRequest was null or undefined when calling postFunktionsbereichAdminHinzufuegenMulti.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/bv/command/funktionsbereiche/v1/admin/hinzufuegen/multi`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<FunktionsbereichIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: funktionsbereichBenutzerMultiRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostFunktionsbereichAnlegen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * FunktionsbereichKeinTitel: (BenutzerverwaltungFunktionsbereichKeinTitel) * KeinMandantAdminBerechtigung: (BenutzerKeinMandantAdmin) 
     * @endpoint post /api/bv/command/funktionsbereiche/v1/anlegen
     * @param funktionsbereichAnlegenRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postFunktionsbereichAnlegen(funktionsbereichAnlegenRequest: FunktionsbereichAnlegenRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<FunktionsbereichIdentifier>;
    public postFunktionsbereichAnlegen(funktionsbereichAnlegenRequest: FunktionsbereichAnlegenRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<FunktionsbereichIdentifier>>;
    public postFunktionsbereichAnlegen(funktionsbereichAnlegenRequest: FunktionsbereichAnlegenRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<FunktionsbereichIdentifier>>;
    public postFunktionsbereichAnlegen(funktionsbereichAnlegenRequest: FunktionsbereichAnlegenRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (funktionsbereichAnlegenRequest === null || funktionsbereichAnlegenRequest === undefined) {
            throw new Error('Required parameter funktionsbereichAnlegenRequest was null or undefined when calling postFunktionsbereichAnlegen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/bv/command/funktionsbereiche/v1/anlegen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<FunktionsbereichIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: funktionsbereichAnlegenRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostFunktionsbereichEMailBenachrichtigungBereitschaft
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * FunktionsbereichNichtGefunden: (BenutzerverwaltungFunktionsbereichNichtGefunden) * FunktionsbereichGeloescht: (BenutzerverwaltungFunktionsbereichGeloescht) * KeinFbAdminOderAdminBerechtigung: (BenutzerverwaltungBenutzerKeinFbAdminOderAdmin) 
     * @endpoint post /api/bv/command/funktionsbereiche/v1/benachrichtigung/bereitschaft/email
     * @param funktionsbereichEmpfaengerRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postFunktionsbereichEMailBenachrichtigungBereitschaft(funktionsbereichEmpfaengerRequest: FunktionsbereichEmpfaengerRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<FunktionsbereichIdentifier>;
    public postFunktionsbereichEMailBenachrichtigungBereitschaft(funktionsbereichEmpfaengerRequest: FunktionsbereichEmpfaengerRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<FunktionsbereichIdentifier>>;
    public postFunktionsbereichEMailBenachrichtigungBereitschaft(funktionsbereichEmpfaengerRequest: FunktionsbereichEmpfaengerRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<FunktionsbereichIdentifier>>;
    public postFunktionsbereichEMailBenachrichtigungBereitschaft(funktionsbereichEmpfaengerRequest: FunktionsbereichEmpfaengerRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (funktionsbereichEmpfaengerRequest === null || funktionsbereichEmpfaengerRequest === undefined) {
            throw new Error('Required parameter funktionsbereichEmpfaengerRequest was null or undefined when calling postFunktionsbereichEMailBenachrichtigungBereitschaft.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/bv/command/funktionsbereiche/v1/benachrichtigung/bereitschaft/email`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<FunktionsbereichIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: funktionsbereichEmpfaengerRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostFunktionsbereichEMailBenachrichtigungFehlerfall
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * FunktionsbereichNichtGefunden: (BenutzerverwaltungFunktionsbereichNichtGefunden) * FunktionsbereichGeloescht: (BenutzerverwaltungFunktionsbereichGeloescht) * KeinFbAdminOderAdminBerechtigung: (BenutzerverwaltungBenutzerKeinFbAdminOderAdmin) 
     * @endpoint post /api/bv/command/funktionsbereiche/v1/benachrichtigung/fehlerfall/email
     * @param funktionsbereichEmpfaengerRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postFunktionsbereichEMailBenachrichtigungFehlerfall(funktionsbereichEmpfaengerRequest: FunktionsbereichEmpfaengerRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<FunktionsbereichIdentifier>;
    public postFunktionsbereichEMailBenachrichtigungFehlerfall(funktionsbereichEmpfaengerRequest: FunktionsbereichEmpfaengerRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<FunktionsbereichIdentifier>>;
    public postFunktionsbereichEMailBenachrichtigungFehlerfall(funktionsbereichEmpfaengerRequest: FunktionsbereichEmpfaengerRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<FunktionsbereichIdentifier>>;
    public postFunktionsbereichEMailBenachrichtigungFehlerfall(funktionsbereichEmpfaengerRequest: FunktionsbereichEmpfaengerRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (funktionsbereichEmpfaengerRequest === null || funktionsbereichEmpfaengerRequest === undefined) {
            throw new Error('Required parameter funktionsbereichEmpfaengerRequest was null or undefined when calling postFunktionsbereichEMailBenachrichtigungFehlerfall.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/bv/command/funktionsbereiche/v1/benachrichtigung/fehlerfall/email`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<FunktionsbereichIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: funktionsbereichEmpfaengerRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostFunktionsbereichExpliziteFreigabeFestlegen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * FunktionsbereichNichtGefunden: (BenutzerverwaltungFunktionsbereichNichtGefunden) * FunktionsbereichGeloescht: (BenutzerverwaltungFunktionsbereichGeloescht) * KeinFbAdminOderAdminBerechtigung: (BenutzerverwaltungBenutzerKeinFbAdminOderAdmin) 
     * @endpoint post /api/bv/command/funktionsbereiche/v1/explizitefreigabe
     * @param funktionsbereichExpliziteFreigabeErforderlichFestlegenRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postFunktionsbereichExpliziteFreigabeFestlegen(funktionsbereichExpliziteFreigabeErforderlichFestlegenRequest: FunktionsbereichExpliziteFreigabeErforderlichFestlegenRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<FunktionsbereichIdentifier>;
    public postFunktionsbereichExpliziteFreigabeFestlegen(funktionsbereichExpliziteFreigabeErforderlichFestlegenRequest: FunktionsbereichExpliziteFreigabeErforderlichFestlegenRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<FunktionsbereichIdentifier>>;
    public postFunktionsbereichExpliziteFreigabeFestlegen(funktionsbereichExpliziteFreigabeErforderlichFestlegenRequest: FunktionsbereichExpliziteFreigabeErforderlichFestlegenRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<FunktionsbereichIdentifier>>;
    public postFunktionsbereichExpliziteFreigabeFestlegen(funktionsbereichExpliziteFreigabeErforderlichFestlegenRequest: FunktionsbereichExpliziteFreigabeErforderlichFestlegenRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (funktionsbereichExpliziteFreigabeErforderlichFestlegenRequest === null || funktionsbereichExpliziteFreigabeErforderlichFestlegenRequest === undefined) {
            throw new Error('Required parameter funktionsbereichExpliziteFreigabeErforderlichFestlegenRequest was null or undefined when calling postFunktionsbereichExpliziteFreigabeFestlegen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/bv/command/funktionsbereiche/v1/explizitefreigabe`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<FunktionsbereichIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: funktionsbereichExpliziteFreigabeErforderlichFestlegenRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostFunktionsbereichFreigabeBerechtigungRolleEntfernen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * FunktionsbereichNichtGefunden: (BenutzerverwaltungFunktionsbereichNichtGefunden) * FunktionsbereichGeloescht: (BenutzerverwaltungFunktionsbereichGeloescht) * KeinFbAdminOderAdminBerechtigung: (BenutzerverwaltungBenutzerKeinFbAdminOderAdmin) 
     * @endpoint post /api/bv/command/funktionsbereiche/v1/freigabeberechtigung/rolle/entfernen
     * @param rolleRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postFunktionsbereichFreigabeBerechtigungRolleEntfernen(rolleRequest: RolleRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<FunktionsbereichIdentifier>;
    public postFunktionsbereichFreigabeBerechtigungRolleEntfernen(rolleRequest: RolleRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<FunktionsbereichIdentifier>>;
    public postFunktionsbereichFreigabeBerechtigungRolleEntfernen(rolleRequest: RolleRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<FunktionsbereichIdentifier>>;
    public postFunktionsbereichFreigabeBerechtigungRolleEntfernen(rolleRequest: RolleRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (rolleRequest === null || rolleRequest === undefined) {
            throw new Error('Required parameter rolleRequest was null or undefined when calling postFunktionsbereichFreigabeBerechtigungRolleEntfernen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/bv/command/funktionsbereiche/v1/freigabeberechtigung/rolle/entfernen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<FunktionsbereichIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: rolleRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostFunktionsbereichFreigabeBerechtigungRolleEntfernenMulti
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * FunktionsbereichNichtGefunden: (BenutzerverwaltungFunktionsbereichNichtGefunden) * FunktionsbereichGeloescht: (BenutzerverwaltungFunktionsbereichGeloescht) * KeinFbAdminOderAdminBerechtigung: (BenutzerverwaltungBenutzerKeinFbAdminOderAdmin) 
     * @endpoint post /api/bv/command/funktionsbereiche/v1/freigabeberechtigung/rolle/entfernen/multi
     * @param rolleMultiRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postFunktionsbereichFreigabeBerechtigungRolleEntfernenMulti(rolleMultiRequest: RolleMultiRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<FunktionsbereichIdentifier>;
    public postFunktionsbereichFreigabeBerechtigungRolleEntfernenMulti(rolleMultiRequest: RolleMultiRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<FunktionsbereichIdentifier>>;
    public postFunktionsbereichFreigabeBerechtigungRolleEntfernenMulti(rolleMultiRequest: RolleMultiRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<FunktionsbereichIdentifier>>;
    public postFunktionsbereichFreigabeBerechtigungRolleEntfernenMulti(rolleMultiRequest: RolleMultiRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (rolleMultiRequest === null || rolleMultiRequest === undefined) {
            throw new Error('Required parameter rolleMultiRequest was null or undefined when calling postFunktionsbereichFreigabeBerechtigungRolleEntfernenMulti.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/bv/command/funktionsbereiche/v1/freigabeberechtigung/rolle/entfernen/multi`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<FunktionsbereichIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: rolleMultiRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostFunktionsbereichFreigabeBerechtigungRolleHinzufuegen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * FunktionsbereichNichtGefunden: (BenutzerverwaltungFunktionsbereichNichtGefunden) * FunktionsbereichGeloescht: (BenutzerverwaltungFunktionsbereichGeloescht) * KeinFbAdminOderAdminBerechtigung: (BenutzerverwaltungBenutzerKeinFbAdminOderAdmin) 
     * @endpoint post /api/bv/command/funktionsbereiche/v1/freigabeberechtigung/rolle/hinzufuegen
     * @param rolleRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postFunktionsbereichFreigabeBerechtigungRolleHinzufuegen(rolleRequest: RolleRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<FunktionsbereichIdentifier>;
    public postFunktionsbereichFreigabeBerechtigungRolleHinzufuegen(rolleRequest: RolleRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<FunktionsbereichIdentifier>>;
    public postFunktionsbereichFreigabeBerechtigungRolleHinzufuegen(rolleRequest: RolleRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<FunktionsbereichIdentifier>>;
    public postFunktionsbereichFreigabeBerechtigungRolleHinzufuegen(rolleRequest: RolleRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (rolleRequest === null || rolleRequest === undefined) {
            throw new Error('Required parameter rolleRequest was null or undefined when calling postFunktionsbereichFreigabeBerechtigungRolleHinzufuegen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/bv/command/funktionsbereiche/v1/freigabeberechtigung/rolle/hinzufuegen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<FunktionsbereichIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: rolleRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostFunktionsbereichFreigabeBerechtigungRolleHinzufuegenMulti
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * FunktionsbereichNichtGefunden: (BenutzerverwaltungFunktionsbereichNichtGefunden) * FunktionsbereichGeloescht: (BenutzerverwaltungFunktionsbereichGeloescht) * KeinFbAdminOderAdminBerechtigung: (BenutzerverwaltungBenutzerKeinFbAdminOderAdmin) 
     * @endpoint post /api/bv/command/funktionsbereiche/v1/freigabeberechtigung/rolle/hinzufuegen/multi
     * @param rolleMultiRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postFunktionsbereichFreigabeBerechtigungRolleHinzufuegenMulti(rolleMultiRequest: RolleMultiRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<FunktionsbereichIdentifier>;
    public postFunktionsbereichFreigabeBerechtigungRolleHinzufuegenMulti(rolleMultiRequest: RolleMultiRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<FunktionsbereichIdentifier>>;
    public postFunktionsbereichFreigabeBerechtigungRolleHinzufuegenMulti(rolleMultiRequest: RolleMultiRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<FunktionsbereichIdentifier>>;
    public postFunktionsbereichFreigabeBerechtigungRolleHinzufuegenMulti(rolleMultiRequest: RolleMultiRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (rolleMultiRequest === null || rolleMultiRequest === undefined) {
            throw new Error('Required parameter rolleMultiRequest was null or undefined when calling postFunktionsbereichFreigabeBerechtigungRolleHinzufuegenMulti.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/bv/command/funktionsbereiche/v1/freigabeberechtigung/rolle/hinzufuegen/multi`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<FunktionsbereichIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: rolleMultiRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostFunktionsbereichLoeschen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * FunktionsbereichNichtGefunden: (BenutzerverwaltungFunktionsbereichNichtGefunden) * FunktionsbereichGeloescht: (BenutzerverwaltungFunktionsbereichGeloescht) * KeinFbAdminOderAdminBerechtigung: (BenutzerverwaltungBenutzerKeinFbAdminOderAdmin) 
     * @endpoint post /api/bv/command/funktionsbereiche/v1/loeschen
     * @param funktionsbereichRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postFunktionsbereichLoeschen(funktionsbereichRequest: FunktionsbereichRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<FunktionsbereichIdentifier>;
    public postFunktionsbereichLoeschen(funktionsbereichRequest: FunktionsbereichRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<FunktionsbereichIdentifier>>;
    public postFunktionsbereichLoeschen(funktionsbereichRequest: FunktionsbereichRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<FunktionsbereichIdentifier>>;
    public postFunktionsbereichLoeschen(funktionsbereichRequest: FunktionsbereichRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (funktionsbereichRequest === null || funktionsbereichRequest === undefined) {
            throw new Error('Required parameter funktionsbereichRequest was null or undefined when calling postFunktionsbereichLoeschen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/bv/command/funktionsbereiche/v1/loeschen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<FunktionsbereichIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: funktionsbereichRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostFunktionsbereichUmbenennen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * FunktionsbereichNichtGefunden: (BenutzerverwaltungFunktionsbereichNichtGefunden) * FunktionsbereichGeloescht: (BenutzerverwaltungFunktionsbereichGeloescht) * KeinFbAdminOderAdminBerechtigung: (BenutzerverwaltungBenutzerKeinFbAdminOderAdmin) 
     * @endpoint post /api/bv/command/funktionsbereiche/v1/umbenennen
     * @param funktionsbereichUmbenennenRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postFunktionsbereichUmbenennen(funktionsbereichUmbenennenRequest: FunktionsbereichUmbenennenRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<FunktionsbereichIdentifier>;
    public postFunktionsbereichUmbenennen(funktionsbereichUmbenennenRequest: FunktionsbereichUmbenennenRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<FunktionsbereichIdentifier>>;
    public postFunktionsbereichUmbenennen(funktionsbereichUmbenennenRequest: FunktionsbereichUmbenennenRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<FunktionsbereichIdentifier>>;
    public postFunktionsbereichUmbenennen(funktionsbereichUmbenennenRequest: FunktionsbereichUmbenennenRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (funktionsbereichUmbenennenRequest === null || funktionsbereichUmbenennenRequest === undefined) {
            throw new Error('Required parameter funktionsbereichUmbenennenRequest was null or undefined when calling postFunktionsbereichUmbenennen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/bv/command/funktionsbereiche/v1/umbenennen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<FunktionsbereichIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: funktionsbereichUmbenennenRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
